import React, { useState } from 'react';
import { getPageThumbnailUrl } from '../api/client';

interface Props {
  name: string;
  pageCount: number;
  onClick: () => void;
  documentId?: number;
  pageNumber?: number;
}

export function DocumentThumbnail({ name, pageCount, onClick, documentId, pageNumber = 1 }: Props) {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const thumbnailUrl = documentId ? getPageThumbnailUrl(documentId, pageNumber) : null;

  return (
    <button
      onClick={onClick}
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        padding: '12px',
        border: '2px solid #ddd',
        borderRadius: '8px',
        background: '#fff',
        cursor: 'pointer',
        minWidth: '140px',
        maxWidth: '160px',
      }}
    >
      <div style={{
        width: '100px',
        height: '130px',
        marginBottom: '8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        background: '#f5f5f5',
        borderRadius: '4px'
      }}>
        {thumbnailUrl && !error ? (
          <img
            src={thumbnailUrl}
            alt={`${name} preview`}
            onLoad={() => setLoaded(true)}
            onError={() => setError(true)}
            style={{
              maxWidth: '100%',
              maxHeight: '100%',
              objectFit: 'contain',
              display: loaded ? 'block' : 'none'
            }}
          />
        ) : null}
        {(!thumbnailUrl || error || !loaded) && (
          <div style={{ fontSize: '32px' }}>📄</div>
        )}
      </div>
      <div style={{ fontWeight: 'bold', textAlign: 'center', fontSize: '14px', wordBreak: 'break-word' }}>{name}</div>
      <div style={{ color: '#666', fontSize: '13px' }}>
        {pageCount === 0 ? '(Full Document)' : `(${pageCount} ${pageCount === 1 ? 'page' : 'pages'})`}
      </div>
    </button>
  );
}
